<template>
  <div>
    <v-row
      class="pa-1"
    >
      <v-col
        cols="12"
        class="py-2 px-3"
      >
        <v-card
          color="white"
          width="100%"
          rounded="lg"
        >
          <v-card-text class="d-flex justify-space-around align-center text-body-2 black--text">
            <div class="d-flex flex-column align-center">
              <img
                :src="myTeamShield || icons.teamShield"
                height="45px"
                width="45px"
                alt="teamShield"
                attrs="teamShield"
                style="background-position: center center; border: 1px solid #f2f2f2; border-radius: 4px;"
              />
              <span class="text-body-2 mt-2">{{ myTeamName }}</span>
            </div>
            <div class="d-flex align-center">
              <span
                class="font-weight-bold text-h6"
                style="color: #3f3f3f;"
              >
                {{ myTeamResult ? myTeamResult : '?' }}
              </span>
              <span class="font-weight-bold text-h6 mx-3">-</span>
              <span
                class="font-weight-bold text-h6"
                style="color: #3f3f3f;"
              >
                {{ rivalTeamResult ? rivalTeamResult : '?' }}
              </span>
            </div>

            <div class="d-flex flex-column align-center">
              <img
                :src="rivalTeamShield || icons.teamShield"
                height="45px"
                width="45px"
                alt="teamShield"
                attrs="teamShield"
                style="background-position: center center; border: 1px solid #f2f2f2; border-radius: 4px;"
              />
              <span class="text-body-2 mt-2">{{ rivalTeamName }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
  mdiChevronRight,
} from '@mdi/js'

export default {
  name: 'ResultsCard',
  props: {
    myTeamName: {
      type: String,
      default: '',
      required: true,
    },
    rivalTeamName: {
      type: String,
      default: '',
      required: true,
    },
    myTeamResult: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    rivalTeamResult: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    myTeamShield: {
      type: String,
      default: '',
    },
    rivalTeamShield: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      icons: {
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        mdiChevronRight,
        teamShield: require('@/assets/images/svg/team-shield.svg'),
      },
    }
  },
}
</script>
